import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Settings from 'material-ui/svg-icons/action/settings';
import {withRouter} from 'react-router';
import {Link} from "react-router-dom";
import {
    BottomNavigation, Checkbox, IconButton, RefreshIndicator,
    BottomNavigationItem, IconMenu, MenuItem, Paper, Dialog, FlatButton,
    FloatingActionButton, Popover, Menu
} from 'material-ui';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import List from 'material-ui/svg-icons/action/list'
import Map from 'material-ui/svg-icons/maps/map'
import ContentAdd from 'material-ui/svg-icons/content/add';
import Place from 'material-ui/svg-icons/maps/place';
import Terrain from 'material-ui/svg-icons/maps/terrain';
import {deletePoint, getPoints, resetPoint} from '../../../store/points/actions';
import {deleteTrail, getTrails, resetTrail} from '../../../store/trails/actions';
import Mapbox, {MapStyle} from '../Mapbox/Mapbox';
import styles from './OpenExplore.css';
import {fetchApp} from "../../../store/apps/actions";
import SearchBox from '../../common/SearchBox/SearchBox';
import Loading from "../../common/Loading/Loading";
import TrailList from "../TrailList/TrailList";
import {search, setMapStyle, setOxListMode} from "../../../store/ui/actions";
import AdminService, {ADMIN} from '../../../services/admin';
import withTranslation from "../../../hoc/withTranslation";
import {
    ADD_POINT_PAGE, ADD_TRAIL_PAGE,
    OPENEXPLORE_LIST_PAGE,
    OPENEXPLORE_MAP_PAGE,
    POINT_PAGE,
    TRAIL_PAGE
} from "../../../constants/routes";
import {getTypes} from "../../../store/types/actions";
import {getCustomFields} from "../../../store/customfields/actions";
import PointList from '../PointList/PointList';
import {normalizeForSearch} from "../../../services/normalizer";

export const DisplayMode = {
    MODE_LIST: 'mode_list',
    MODE_MAP: 'mode_map'
};

export const ListDisplayMode = {
    POINTS: 0,
    TRAILS: 1
};

export class OpenExplore extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        match: PropTypes.object
    };

    static defaultProps = {
        loading: true,
        app: null
    };

    state = {
        floatingPopoverOpened: false,
        floatingAnchorElement: null,
        openRemovePoint: false,
        openRemoveTrail: false,
        pointToRemove: null,
        trailToRemove: null,
        displayPoints: true,
        displayTrails: true,
        listMode: this.props.listMode
    };

    componentWillMount() {
        this.props.resetPoint();
        this.props.resetTrail();
        this.fetchApplication();

        if (this.props.app && this.props.currentLang) {
            this.props.getPoints(this.props.app, this.props.currentLang);
            this.props.getTrails(this.props.app, this.props.currentLang);
            this.props.getTypes(this.props.app.id, this.props.currentLang);
            this.props.getCustomFields(this.props.app.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetchApplication(nextProps.match.params.appId);
        }

        if (this.props.isPointSending && !nextProps.isPointSending) {
            this.handleClosePoint()
        }

        if (this.props.isTrailSending && !nextProps.isTrailSending) {
            this.handleCloseTrail()
        }

        if (this.props.app !== nextProps.app && nextProps.app && nextProps.currentLang) {
            this.props.getPoints(nextProps.app, nextProps.currentLang);
            this.props.getTrails(nextProps.app, nextProps.currentLang);
            this.props.getTypes(nextProps.app.id, nextProps.currentLang);
            this.props.getCustomFields(nextProps.app.id);
        }
        this.setState({
            listMode: nextProps.listMode
        });

        if (nextProps.app && !nextProps.cfs && !nextProps.cfPending) {
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    // Logic

    fetchApplication(appId = null) {
        if (this.props.match) {
            let id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    filteredPoints() {
        const {searchValue} = this.props;

        if (!searchValue || searchValue.length === 0) {
            return this.props.points[this.props.currentLang];
        }

        const formattedSearch = normalizeForSearch(searchValue);

        return this.props.points[this.props.currentLang].filter((point) => {
            const includesName = point.name && normalizeForSearch(point.name).includes(formattedSearch);
            const includesDesc = point.description && normalizeForSearch(point.description).includes(formattedSearch);

            return includesName || includesDesc;
        });
    }

    filteredTrails() {
        const {searchValue} = this.props;

        if (!searchValue || searchValue.length === 0) {
            return this.props.trails[this.props.currentLang];
        }

        const formattedSearch = normalizeForSearch(searchValue);

        return this.props.trails[this.props.currentLang].filter((trail) => {
            const includesName = trail.name && normalizeForSearch(trail.name).includes(formattedSearch);
            const includesDesc = trail.description && normalizeForSearch(trail.description).includes(formattedSearch);

            return includesName || includesDesc;
        });
    }

    // Handlers

    onPointsChecked = (event, isInputChecked) => {
        event.stopPropagation();
        this.setState({
            displayPoints: isInputChecked
        })
    };

    onTrailsChecked = (event, isInputChecked) => {
        event.stopPropagation();
        this.setState({
            displayTrails: isInputChecked
        })
    };

    onSearchChanged = (event, value) => {
        this.props.search(value);
    };

    onPointClicked = (point) => {
        let url = POINT_PAGE.replace(':appId', this.props.app.id).replace(':pointId', point.id);
        this.props.history.push(url);
    };

    onTrailClicked = (trail) => {
        let url = TRAIL_PAGE.replace(':appId', this.props.app.id).replace(':trailId', trail.id);
        this.props.history.push(url);
    };

    onListElementNavigationClicked = (index) => {
        this.props.setOxListMode(index);
    };

    onMapStyleChanged = (style) => {
        this.props.setMapStyle(style);
    };

    // Delete point

    handleRemovePoint = (point) => {
        this.setState({
            openRemovePoint: true,
            pointToRemove: point
        });
    };

    handleClosePoint = () => {
        this.setState({
            openRemovePoint: false,
            pointToRemove: null
        });
    };

    deletePoint = () => {
        this.props.deletePoint(this.props.app.id, this.state.pointToRemove.id, this.props.currentLang);
    };


    // Delete Trail

    handleRemoveTrail = (trail) => {
        this.setState({
            openRemoveTrail: true,
            trailToRemove: trail
        });
    };

    handleCloseTrail = () => {
        this.setState({
            openRemoveTrail: false,
            trailToRemove: null
        });
    };

    deleteTrail = () => {
        this.props.deleteTrail(this.props.app.id, this.state.trailToRemove.id, this.props.currentLang);
    };

    // Floating Button

    handleOpenFloatingButton = (event) => {
        event.preventDefault();

        this.setState({
            floatingPopoverOpened: true,
            floatingAnchorElement: event.currentTarget
        });
    };

    handleCloseFloatingButton = () => {
        this.setState({
            floatingPopoverOpened: false,
            floatingAnchorElement: null
        });
    };


    // Render

    toolbarContainerStyle() {
        let style = styles.toolBar.container;

        if (this.props.mode === DisplayMode.MODE_MAP) {
            style = {
                ...style,
                ...styles.toolBar.containerMap
            }
        } else {
            style = {
                ...style,
                ...styles.toolBar.containerList
            }
        }

        return style;
    }

    renderToolbar() {
        return (
            <Toolbar style={this.toolbarContainerStyle()}>
                <ToolbarGroup firstChild={true} style={styles.toolBar.searchBar}>
                    <SearchBox
                        onChange={this.onSearchChanged}
                        value={this.props.searchValue}
                    />
                </ToolbarGroup>
                {this.props.mode === DisplayMode.MODE_MAP &&
                    <ToolbarGroup>
                        <ToolbarTitle text={this.props.t('module.open_explore.filters')} />
                        <ToolbarSeparator />
                        <span style={styles.toolBar.checkBox.container}>
                            <Checkbox
                                checked={this.state.displayPoints}
                                style={styles.toolBar.checkBox.item}
                                label={this.props.t('module.open_explore.point_plural')}
                                onCheck={this.onPointsChecked}
                            />
                            <Checkbox
                                checked={this.state.displayTrails}
                                style={styles.toolBar.checkBox.item}
                                label={this.props.t('module.open_explore.trail_plural')}
                                onCheck={this.onTrailsChecked}
                            />
                        </span>
                    </ToolbarGroup>
                }
                <ToolbarGroup>
                    {this.props.mode === DisplayMode.MODE_MAP &&
                        <Link to={OPENEXPLORE_LIST_PAGE.replace(':appId', this.props.app.id)}>
                            <IconButton
                                onClick={this.onListTriggered}
                                tooltip={this.props.t('module.open_explore.list_mode')}
                                tooltipPosition='bottom-center'
                            >
                                <List/>
                            </IconButton>
                        </Link>
                    }
                    {this.props.mode === DisplayMode.MODE_MAP &&
                        <IconMenu
                            iconButtonElement={
                                <IconButton
                                    tooltip={this.props.t('module.open_explore.map_style_tooltip')}
                                    tooltipPosition='bottom-center'
                                >
                                    <Settings />
                                </IconButton>
                            }
                            targetOrigin={{horizontal: 'right', vertical: 'top'}}
                            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        >
                            <MenuItem
                                primaryText={this.props.t('module.open_explore.map_style.streets')}
                                onClick={() => this.onMapStyleChanged(MapStyle.STREETS) }
                                checked={this.props.mapStyle === MapStyle.STREETS}
                            />
                            <MenuItem
                                primaryText={this.props.t('module.open_explore.map_style.satellite')}
                                onClick={() => this.onMapStyleChanged(MapStyle.SATELLITE) }
                                checked={this.props.mapStyle === MapStyle.SATELLITE}
                            />
                            <MenuItem
                                primaryText={this.props.t('module.open_explore.map_style.outdoors')}
                                onClick={() => this.onMapStyleChanged(MapStyle.OUTDOORS) }
                                checked={this.props.mapStyle === MapStyle.OUTDOORS}
                            />
                            <MenuItem
                                primaryText={this.props.t('module.open_explore.map_style.light')}
                                onClick={() => this.onMapStyleChanged(MapStyle.LIGHT) }
                                checked={this.props.mapStyle === MapStyle.LIGHT}
                            />
                            <MenuItem
                                primaryText={this.props.t('module.open_explore.map_style.dark')}
                                onClick={() => this.onMapStyleChanged(MapStyle.DARK) }
                                checked={this.props.mapStyle === MapStyle.DARK}
                            />
                        </IconMenu>
                    }
                    {this.props.mode === DisplayMode.MODE_LIST &&
                        <Link to={OPENEXPLORE_MAP_PAGE.replace(':appId', this.props.app.id)}>
                            <IconButton
                                tooltip={this.props.t('module.open_explore.map_mode')}
                                tooltipPosition='bottom-center'
                            >
                                <Map/>
                            </IconButton>
                        </Link>
                    }
                </ToolbarGroup>
            </Toolbar>
        );
    }

    renderMap(points, trails) {
        return (
            <span>
                <Mapbox
                    mapStyle={this.props.mapStyle}
                    style={styles.map}
                    points={points}
                    trails={trails}
                    onPointClicked={this.onPointClicked}
                    onTrailClicked={this.onTrailClicked}
                />
                <RefreshIndicator
                    size={50}
                    left={70}
                    top={0}
                    loadingColor="#FF9800"
                    status={this.props.loading ? 'loading' : 'hide'}
                    style={styles.loader}
                />
            </span>
        );
    }

    renderList(points, types, trails) {
        let bottomNavigationBarStyle = styles.list.bottomNavigationBar;
        bottomNavigationBarStyle.paddingLeft = this.props.navLeftPadding;

        return (
            <div>
                <Paper style={bottomNavigationBarStyle} zDepth={1}>
                    <BottomNavigation selectedIndex={this.state.listMode}>
                        <BottomNavigationItem
                            label={this.props.t('module.open_explore.point_plural')}
                            icon={<Place />}
                            onClick={() => this.onListElementNavigationClicked(ListDisplayMode.POINTS)}
                        />
                        <BottomNavigationItem
                            label={this.props.t('module.open_explore.trail_plural')}
                            icon={<Terrain />}
                            onClick={() => this.onListElementNavigationClicked(ListDisplayMode.TRAILS)}
                        />
                    </BottomNavigation>
                </Paper>
                <div style={styles.list.container}>
                    {this.state.listMode === ListDisplayMode.POINTS &&
                        <PointList
                            app={this.props.app}
                            user={this.props.user}
                            points={points}
                            customFields={this.props.cfs ? this.props.cfs.filter(cf => cf.visible) : []}
                            title={this.props.t('module.open_explore.point_plural')}
                            handleRemovePoint={this.handleRemovePoint}
                            onPointClicked={this.onPointClicked}
                        />
                    }
                    {this.state.listMode === ListDisplayMode.TRAILS &&
                        <TrailList
                            app={this.props.app}
                            user={this.props.user}
                            trails={trails}
                            title={this.props.t('module.open_explore.trail_plural')}
                            handleRemoveTrail={this.handleRemoveTrail}
                        />
                    }
                </div>
            </div>
        );
    }

    renderDeletePointDialog(point) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.isPointSending}
                onClick={this.handleClosePoint}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.isPointSending}
                onClick={this.deletePoint}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.isPointSending}
                    open={this.state.openRemovePoint}
                    onRequestClose={this.handleClosePoint}>
                {this.props.isPointSending && <Loading paper={false} />}
                {!this.props.isPointSending &&
                    <span>
                        <div dangerouslySetInnerHTML={{
                            __html: this.props.t('module.open_explore.remove_point_confirmation', {
                                name: point.name
                            })
                        }}/>
                    </span>
                }
            </Dialog>
        );
    }

    renderDeleteTrailDialog(trail) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.isTrailSending}
                onClick={this.handleCloseTrail}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.isTrailSending}
                onClick={this.deleteTrail}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.isTrailSending}
                    open={this.state.openRemoveTrail}
                    onRequestClose={this.handleCloseTrail}>
                {this.props.isTrailSending && <Loading paper={false} />}
                {!this.props.isTrailSending &&
                    <span>
                        <div dangerouslySetInnerHTML={{
                            __html: this.props.t('module.open_explore.remove_trail_confirmation', {
                                name: trail.name
                            })
                        }}/>
                    </span>
                }
            </Dialog>
        );
    }

    renderFloatingButton() {
        return (
            <div>
                <Popover
                    open={this.state.floatingPopoverOpened}
                    anchorEl={this.state.floatingAnchorElement}
                    anchorOrigin={{horizontal: 'left', vertical: 'top'}}
                    targetOrigin={{horizontal: 'left', vertical: 'center'}}
                    onRequestClose={this.handleCloseFloatingButton}
                >
                    <Menu>
                        <Link to={ADD_POINT_PAGE.replace(':appId', this.props.app.id)}>
                            <MenuItem
                                primaryText={this.props.t('module.open_explore.point')}
                                leftIcon={<Place/>}
                            />
                        </Link>
                        <Link to={ADD_TRAIL_PAGE.replace(':appId', this.props.app.id)}>
                            <MenuItem
                                primaryText={this.props.t('module.open_explore.trail')}
                                leftIcon={<Terrain/>}
                            />
                        </Link>
                    </Menu>
                </Popover>
                <FloatingActionButton
                    style={styles.floatingButton}
                    onClick={this.handleOpenFloatingButton}
                >
                    <ContentAdd />
                </FloatingActionButton>
            </div>
        );
    }

    render() {
        // No app loading anyway
        if (!this.props.app) {
            return <Loading paper={false} />
        }

        // In list mode, show loader
        if (this.props.mode === DisplayMode.MODE_LIST && this.props.loading) {
            return <Loading paper={false} />
        }

        const points = this.state.displayPoints ? this.filteredPoints() : [];
        const trails = this.state.displayTrails ? this.filteredTrails() : [];
        const types = this.props.types;

        return (
            <div style={styles.container}>
                {this.state.pointToRemove && this.renderDeletePointDialog(this.state.pointToRemove)}
                {this.state.trailToRemove && this.renderDeleteTrailDialog(this.state.trailToRemove)}

                {this.props.mode === DisplayMode.MODE_MAP && this.renderMap(points, trails)}
                {this.props.mode === DisplayMode.MODE_LIST && this.renderList(points, types, trails)}

                {this.renderToolbar()}
                {AdminService.isAuthorized(ADMIN, this.props.user) && this.renderFloatingButton()}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        isTrailSending: state.trails.sending,
        isPointSending: state.points.sending,
        loading: state.points.pending || state.trails.pending || state.types.pending,
        points: state.points.content,
        trails: state.trails.content,
        user: state.auth.content,
        currentLang: state.ui.currentLang,
        navLeftPadding: state.ui.leftPadding,
        searchValue: state.ui.search,
        mapStyle: state.ui.mapStyle,
        listMode: state.ui.oxListMode,
        types: state.types.content,
        cfs: state.customFields.content,
        cfPending: state.customFields.pending
    };

    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }

    if (!ownProps.mode) {
        props.mode = state.ui.oxMode
    }

    if (!ownProps.listMode) {
        props.listMode = state.ui.oxListMode
    }

    return props;
}

export default connect(mapStateToProps, {
    getPoints,
    getTrails,
    fetchApp,
    search,
    setMapStyle,
    deletePoint,
    deleteTrail,
    resetPoint,
    resetTrail,
    setOxListMode,
    getCustomFields,
    getTypes
})(withRouter(withTranslation(OpenExplore)));



// WEBPACK FOOTER //
// src/components/openexplore/OpenExplore/OpenExplore.js